"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateInterstitial = void 0;
const features_1 = require("../../features");
const initializer_1 = require("../../initializer");
const react_1 = require("react");
const useUpdateInterstitialBase_hook_1 = require("./useUpdateInterstitialBase.hook");
const useUpdateInterstitial = () => {
    const interstitialsRepository = (0, react_1.useRef)(new features_1.InterstitialsRepository(initializer_1.API));
    return (0, useUpdateInterstitialBase_hook_1.useUpdateInterstitialBase)(interstitialsRepository.current);
};
exports.useUpdateInterstitial = useUpdateInterstitial;
//# sourceMappingURL=useUpdateInterstitial.hook.js.map